import { useQuery } from "@tanstack/react-query";

import { queryKeys } from "../queryKeys";
import { getIpAddress, type IpAddressResponse } from "../rest/ip";

const STUB_IP = "127.0.0.1";

export const useGetIpAddress = () => {
  // This request will always fail when not on prod
  const isDevOrStg = ["DEV", "STG"].includes(window.env.ENV);

  const { data } = useQuery<IpAddressResponse>({
    queryKey: queryKeys.ipAddress(),
    queryFn: getIpAddress,
    gcTime: 0,
    enabled: !isDevOrStg,
  });

  return {
    ipAddress: isDevOrStg ? STUB_IP : (data?.ip_address ?? ""),
  };
};

export default useGetIpAddress;
